import kbpayApiClient from './kbpayApiClient'

const KbpayAPI = {
  cancelLiveShopping: async () => {
    try {
      const res = await kbpayApiClient.post(`/external/delete/member/callback/kbpay`)
      return res.data
    } catch (error) {
      return null
    }
  },
}

export default KbpayAPI
